// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2-6vG","noInteraction":"EventWrapper_noInteraction__1I7pV"};